import React, { useState } from "react";
import { Button, message, Space, Input, Empty, App } from "antd";
//
//component
//redux
//selector
//actions
//function
//str

import { generateQRCode } from "store/bailiff/dev/dev.action";
const DevScreen = () => {
  // -------------------------- VAR -----------------------------
  const { message } = App?.useApp();
  // -------------------------- STATE ---------------------------
  const [loading, setLoading] = useState(false);
  const [qrcode, setQRcode] = useState(null);
  const [id, setId] = useState("");
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  const handleGenerate = () => {
    if (id === "") return message.error("Không được để trống");
    setLoading(true);
    generateQRCode({ id }, (res) => {
      setLoading(false);
      if (res?.status === 200) {
        setQRcode(res.data);
      }
      if (res?.status === 500) {
        message.error(res?.data);
      }
    });
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderQRCode = () => {
    if (!qrcode) return null;
    return (
      <img
        src={qrcode}
        style={{ width: 300, height: 300, marginTop: 20 }}
        alt="qrcode"
      />
    );
  };

  const renderEmpty = () => {
    if (qrcode) return null;
    return (
      <Empty description="Không có QR" style={{ width: 300, minHeight: 300 }} />
    );
  };
  // -------------------------- MAIN ----------------------------
  return (
    <div
      className="content-no-bg"
      style={{ width: "100%", padding: 20, minHeight: "100vh" }}
    >
      <Space>
        <Input
          placeholder="Nhập ID payment"
          style={{ width: 300 }}
          onChange={(e) => setId(e?.target?.value)}
        />
        <Button loading={loading} disabled={id === ""} onClick={handleGenerate}>
          Generate QR code
        </Button>
      </Space>
      <div style={{ marginTop: 30 }}>
        {renderQRCode()}
        {renderEmpty()}
      </div>
    </div>
  );
};
export default DevScreen;

// const renderEntries = (entries) => {
//   const group = lodash.groupBy(entries, "speaker");

//   const result = Object.entries(group)?.map(([speaker, arrays]) => {
//     const segment = arrays?.map((a) => a?.segment)?.join(" ");
//     return { speaker, segment };
//   });

//   return result;
// };
